import axiosWrapper from "./wrapper";

export function create({netId, reason, additionalService, photo, paymentMethod}) {
  const response = axiosWrapper(
    "post",
    '/api/application/create',
    {
      netId: netId,
      reason: reason,
      additionalService: additionalService,
      photo: photo,
      paymentMethod: paymentMethod,
    }
  );
  return response;
}

export function getPendingCount({searchType, netId}) {
  const response = axiosWrapper(
    "post",
    '/api/application/pending/count',
    {
      searchType: searchType,
      netId: netId,
    }
  );
  return response;
}

export function search({searchType, netId, pageSize, pageNum}) {
  const response = axiosWrapper(
    "post",
    '/api/application/search',
    {
      searchType: searchType,
      netId: netId,
      pageSize: pageSize,
      pageNum: pageNum,
    }
  );
  return response;
}

export function updatePhoto({applicationId, photo}) {
  const response = axiosWrapper(
    "post",
    `/api/application/${applicationId}/photo/update`,
    {
      photo: photo
    }
  );
  return response;
}

export function getPaymentStatus({netId, applicationId}) {
  const response = axiosWrapper(
    "post",
    `/api/application/${applicationId}/paymentStatus/get`,
    {
      netId: netId
    }
  );
  return response;
}

export function updatePaymentDetails({applicationId, paymentMethod}) {
  const response = axiosWrapper(
    "post",
    `/api/application/${applicationId}/paymentDetails/update`,
    {
      paymentMethod: paymentMethod,
    }
  );
  return response;
}